module.exports = __webpack_public_path__ + "assets/img/101.2650798d.png";